import { lazy } from 'react';

import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';

const UploadContents = lazy(() => import('./components/UploadContents'));

export default function UploadDocumentsModal({ handleClose }) {
  return (
    <FormModal
      handleBack={handleClose}
      handleClose={handleClose}
      title="Open a business bank account"
    >
      <UploadContents handleClose={handleClose} />
    </FormModal>
  );
}

UploadDocumentsModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
